import { Icon } from "./Icon.tsx";

/** Theme toggle icon shown while in light mode (click to switch to dark). */
export function SunIcon() {
  return (
    <Icon>
      <circle cx="12" cy="12" r="4.5" />
      <path d="M12 2.5v3M12 18.5v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2.5 12h3M18.5 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
    </Icon>
  );
}
